
//  TS Versión Navidad 2025 - Original al pie de código
// import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
// import { AuthService } from '../../services/auth.service';

// type Flake = {
//     x: number; y: number;
//     r: number;
//     vy: number;
//     vx: number;
//     phase: number;
//     sway: number;
//     spin: number;
//     alpha: number;
// };

// @Component({
//     selector: 'app-callback',
//     templateUrl: './callback.component.html',
//     styleUrls: ['./callback.component.scss']
// })
// export class CallbackComponent implements AfterViewInit, OnDestroy {
//     @ViewChild('scene', { static: true }) sceneRef!: ElementRef<HTMLElement>;
//     @ViewChild('snowCanvas', { static: true }) canvasRef!: ElementRef<HTMLCanvasElement>;
//     private ctx!: CanvasRenderingContext2D;
//     private rafId: number | null = null;

//     private flakes: Flake[] = [];
//     private lastT = 0;

//     // Ajustes
//     private density = 0.00012;
//     private maxSnowPx = 220;
//     private growPxPerSecond = 14;

//     // --- NUEVAS PROPIEDADES PARA ACUMULACIÓN IRREGULAR ---
//     private snowLevel = 0;
//     private snowProfile: number[] = [];
//     private profileColumns = 60;
//     // ----------------------------------------------------

//     private dpr = 1;

//     constructor(private auth: AuthService) { }

//     ngAfterViewInit(): void {
//         const canvas = this.canvasRef.nativeElement;
//         const ctx = canvas.getContext('2d', { alpha: true });
//         if (!ctx) return;
//         this.ctx = ctx;

//         this.handleResize = this.handleResize.bind(this);
//         window.addEventListener('resize', this.handleResize, { passive: true });
//         this.handleResize();

//         this.lastT = performance.now();
//         this.rafId = requestAnimationFrame(this.tick);
//         this.auth.callback();
//     }
//     ngOnDestroy(): void {
//         if (this.rafId != null) cancelAnimationFrame(this.rafId);
//         window.removeEventListener('resize', this.handleResize);
//     }

//     private handleResize(): void {
//         const canvas = this.canvasRef.nativeElement;
//         const rect = canvas.getBoundingClientRect();

//         this.dpr = Math.max(1, window.devicePixelRatio || 1);
//         canvas.width = Math.floor(rect.width * this.dpr);
//         canvas.height = Math.floor(rect.height * this.dpr);

//         this.ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);

//         // --- MODIFICACIÓN: Inicializar/redimensionar snowProfile ---
//         const initialHeight = this.snowLevel;
//         if (this.snowProfile.length !== this.profileColumns) {
//             this.snowProfile = new Array(this.profileColumns).fill(initialHeight);
//         }
//         // -----------------------------------------------------------

//         // Recalcular cantidad de copos según área (más grande => más copos)
//         const targetCount = Math.floor(rect.width * rect.height * this.density);
//         this.reseed(targetCount, rect.width, rect.height);
//     }

//     // ... (reseed y spawnFlake sin cambios)

//     private reseed(targetCount: number, w: number, h: number) {
//         while (this.flakes.length < targetCount) this.flakes.push(this.spawnFlake(w, h, true));
//         while (this.flakes.length > targetCount) this.flakes.pop();
//     }

//     private spawnFlake(w: number, h: number, randomY = false): Flake {
//         const r = this.rand(0.8, 3.2);
//         const slow = (3.2 - r) / 3.2;
//         return {
//             x: this.rand(0, w),
//             y: randomY ? this.rand(0, h) : this.rand(-h * 0.15, -10),
//             r,
//             vy: this.rand(18, 70) * (0.55 + slow * 0.6),
//             vx: this.rand(-10, 10) * (0.4 + (1 - slow) * 0.6),
//             phase: this.rand(0, Math.PI * 2),
//             sway: this.rand(6, 22) * (0.4 + slow * 0.8),
//             spin: this.rand(-0.8, 0.8),
//             alpha: this.rand(0.35, 0.95),
//         };
//     }

//     private tick = (now: number) => {
//         const canvas = this.canvasRef.nativeElement;
//         const w = canvas.getBoundingClientRect().width;
//         const h = canvas.getBoundingClientRect().height;

//         // dt en segundos, clamp para evitar saltos si cambia de pestaña
//         const dt = Math.min(0.033, Math.max(0.001, (now - this.lastT) / 1250));
//         this.lastT = now;

//         // --- MODIFICACIÓN: Crecimiento base del paquete con ruido ---
//         const baseGrowth = this.growPxPerSecond * dt;
//         for (let i = 0; i < this.profileColumns; i++) {
//             // Si quieres un crecimiento base más errático, aumenta el rango
//             const noise = this.rand(-0.3, 0.3); // Ajustado de -0.15/0.15 a -0.3/0.3
//             this.snowProfile[i] = Math.min(this.maxSnowPx, this.snowProfile[i] + baseGrowth * (1 + noise));
//         }

//         // Calcular el nivel promedio para actualizar el CSS (el fondo)
//         this.snowLevel = this.snowProfile.reduce((a, b) => a + b, 0) / this.profileColumns;
//         this.sceneRef.nativeElement.style.setProperty('--snow-level', `${this.snowLevel.toFixed(0)}px`);
//         // -------------------------------------------------------------

//         // El suelo dinámico ahora es un valor ficticio, la lógica real está en draw
//         const groundY = h - this.snowLevel;

//         this.draw(dt, w, h, groundY, now / 1000);

//         this.rafId = requestAnimationFrame(this.tick);
//     };

//     private draw(dt: number, w: number, h: number, groundY: number, t: number) {
//         const ctx = this.ctx;
//         ctx.clearRect(0, 0, w, h);

//         // Copos
//         for (let i = 0; i < this.flakes.length; i++) {
//             const f = this.flakes[i];

//             // Movimiento: caída + deriva + sway sinusoidal (sin cambios)
//             f.phase += dt * (0.9 + f.spin * 0.25);
//             f.y += f.vy * dt;
//             f.x += (f.vx + Math.sin(f.phase + t * 0.4) * f.sway) * dt;

//             // Wrap lateral (sin cambios)
//             if (f.x < -10) f.x = w + 10;
//             if (f.x > w + 10) f.x = -10;

//             // --- MODIFICACIÓN: Colisión con el perfil de nieve irregular ---
//             const colIndex = Math.floor((f.x / w) * this.profileColumns);
//             // Aseguramos que el índice sea válido
//             const validColIndex = Math.min(this.profileColumns - 1, Math.max(0, colIndex));

//             // La altura del suelo depende de la columna donde cae el copo
//             const flakeGroundY = h - this.snowProfile[validColIndex];

//             // Si toca "suelo" (flakeGroundY - f.r es más preciso)
//             if (f.y > flakeGroundY - f.r) {
//                 // 1. Aumentar la altura de la columna donde cayó
//                 // Incremento basado en el radio del copo y un pequeño factor random
//                 this.snowProfile[validColIndex] = Math.min(
//                     this.maxSnowPx,
//                     // Aumentamos el impacto: 
//                     this.snowProfile[validColIndex] + f.r * this.rand(0.1, 0.3) // Ajustado de 0.05/0.15 a 0.1/0.3
//                 );

//                 // 2. Respawnear el copo
//                 this.flakes[i] = this.spawnFlake(w, h, false);
//                 continue;
//             }
//             // ---------------------------------------------------------------

//             // Dibujar el copo (sin cambios)
//             ctx.globalAlpha = f.alpha;
//             ctx.beginPath();
//             ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
//             ctx.fillStyle = '#ffffff';
//             ctx.fill();
//         }

//         ctx.globalAlpha = 1;

//         // --- NUEVO: Dibujar el perfil de nieve acumulada ---
//         this.drawSnowProfile(w, h, ctx);
//     }

//     private drawSnowProfile(w: number, h: number, ctx: CanvasRenderingContext2D) {
//         const colWidth = w / this.profileColumns;

//         ctx.fillStyle = '#ffffff';
//         ctx.globalAlpha = 1;

//         // Suavizar un poco las uniones
//         ctx.lineJoin = 'round';
//         ctx.lineCap = 'round';

//         ctx.beginPath();
//         ctx.moveTo(0, h);

//         // Dibujar la parte superior del perfil irregular
//         for (let i = 0; i < this.profileColumns; i++) {
//             const x = i * colWidth;
//             const y = h - this.snowProfile[i];
//             ctx.lineTo(x, y);
//         }

//         ctx.lineTo(w, h);
//         ctx.closePath();
//         ctx.fill();
//     }

//     private rand(min: number, max: number) {
//         return min + Math.random() * (max - min);
//     }
// }


import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../../services/auth.service';
@Component({
 selector: 'app-callback',
templateUrl: './callback.component.html',
   styleUrls: ['./callback.component.scss']
 })
 export class CallbackComponent implements OnInit {
   constructor(private auth: AuthService) { }
   ngOnInit(): void {
     this.auth.callback();
   }
 }


